import styled from 'styled-components';
export const CompleteForm = styled.div`
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 100vh;
`;
